import React, { Component } from "react";
import { SearchIcons } from "./SearchIcons";

class AssetSearchEndAdornment extends Component {
    render () {
        const { onClearSearch, search, selectedTags } = this.props;

        if (search === '' && !selectedTags.length) {
            return null;
        }

        return (
            <SearchIcons
                iconName="close"
                styles={{
                    color: 'rgb(146, 146, 146)',
                    paddingLeft: '10px',
                    cursor: 'pointer',
                }}
                onClick={onClearSearch}
            />
        );
    }
};

export default AssetSearchEndAdornment;



// WEBPACK FOOTER //
// ./src/components/search/AssetSearchEndAdornment.js